import createCachedSelector from "re-reselect";
import { createSelector } from "reselect";

import type { PollService } from "@busbud/core-types";

import { getSearchedLegByTripId } from "./get-leg";
import { getTripsSegments } from "../state-accessors";

const getSearchedLegSegmentIds = createSelector(
  [getSearchedLegByTripId],
  leg => leg?.segment_ids || []
);

export const getSearchedLegSegments = createCachedSelector(
  [getSearchedLegSegmentIds, getTripsSegments],
  (
    segment_ids,
    trips_segments
  ): (
    | PollService.API.RelatedPublicSegment
    | PollService.API.RelatedPublicSegmentV4
  )[] => {
    // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    return segment_ids.map(segment_id => trips_segments[segment_id]);
  }
)((_state, trip_id) => trip_id);

export const hasSearchDetails = createSelector(
  getSearchedLegSegments,
  segments => {
    // Departure service sets segment's stops to undefined when a call to the searchDetails endpoint
    // is needed to resolve them. Otherwise, any array values (i.e. empty or filled) mean we already
    // have all the stops for this segment and no extra fetching is needed.
    return segments.some(segment => !segment.stops);
  }
);
